export enum ContextMenuType { APPOINTMENT, BACKGROUND, NONE}
